import { VirtualItem } from '@tanstack/react-virtual';
import { createContext, useContext } from 'react';
import { VirtualMessagingThreadItem } from '../util';

interface IVirtualMessageThreadContainerContext {
  virtualItem: VirtualItem;
  virtualizerItems: VirtualMessagingThreadItem[];
}

export const VirtualMessageThreadContainerContext = createContext<null | IVirtualMessageThreadContainerContext>(null);

export function useVirtualMessageThreadContainerContext() {
  const context = useContext(VirtualMessageThreadContainerContext);
  if (!context) throw new Error('Make sure to use the LoanFormContext inside of the provider');
  return context;
}
